import { Routes } from '@angular/router';

import {
  canLoadDesktopVersion,
  canLoadMobileVersion,
} from '@Login/pages/login-view/login.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('@Login/pages/login-view/login-view.component').then(
        (m) => m.LoginViewComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('@FieldOperation/fieldOperation.component').then(
        (m) => m.FieldOperationComponent
      ),
    canMatch: [canLoadMobileVersion],
    loadChildren: () => import('@FieldOperation/fieldOperation.routes'),
  },
  {
    path: 'work-management',
    loadComponent: () =>
      import('@WorkManagement/work-management.component').then(
        (m) => m.WorkManagementComponent
      ),
    canMatch: [canLoadDesktopVersion],
    loadChildren: () => import('@WorkManagement/work-management.routes'),
  },
];
